package pwgs

import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.HTMLElement
import pwgs.ui.MainScene
import visage.core.Navigation
import visage.core.Visage
import visage.ds.colorpalette.DefaultDarkPalette
import visage.ds.colorpalette.DefaultLightPalette
import visage.ds.colorpalette.Skin

fun main() {
    window.onload = {
        start()
    }
}

fun start() {
    Skin.palette = DefaultDarkPalette()
    Visage.init(document.getElementById("root") as HTMLElement) {
        MainScene()
    }
    Navigation.init()
    Navigation.onLocationChanged.addListener {
        Visage.rerender()
    }
    Visage.rerender()
}